import React, {Component} from 'react';
import NavBarKS from "../../components/NavBarKS";
import StickButton from "../../components/StickButton";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import axios from "axios";
import {request} from "../../helper/APIUtils";
import {hasUserRight, showAxiosError} from "../../helper/helper";
import AddTagList from "./AddTagList";
import Table from "../../components/Table/Table";
import Alert from "react-s-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import {UserRightsEnum} from "../../helper/enums";
import {VirtualHost} from "../../constants";

const selectDefineType = [
	{value: "0", label: 'Giden İrsaliye'},
	{value: "1", label: 'Gelen İrsaliye'},
	{value: "2", label: 'Giden E-Fatura'},
	{value: "3", label: 'Gelen E-Fatura'},
	{value: "4", label: 'E-Arşiv Fatura'},
	{value: "5", label: 'E-Müstahsil Makbuzlar'},
	{value: "6", label: 'E-Serbest Meslek Makbuzlar'}

];

class TagList extends Component {
	constructor(props) {
		super(props);
		this.state = {

			addOpen: false,
			content: [],
			total: 0,
			loading: false,
			page: 0,
			size: 5,
			sendBtnDisabled: false,
			manual: false,
			deleteBtnDisabled: false,
			item: null,
			index: -1,
			url: null,
			mediaModal: false,
			searchQuery: undefined,
			selection: [],
			selectedAll: false,
			alert: false,
			row: null,
			defineTagList: []
		};

		this.handleSearch = this.handleSearch.bind(this);
		this.fetchData = this.fetchData.bind(this);
		this.closeClick = this.closeClick.bind(this);
		this.defineType = this.defineType.bind(this);
		this.deleteTag = this.deleteTag.bind(this);
		this.getTagName = this.getTagName.bind(this);

	}

	handleSearch(searchQuery) {
		this.setState({
			searchQuery,
			searching: true
		}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	fetchData(accessor, direction, page, size) {
		let self = this;
		this._source = axios.CancelToken.source();
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc'
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/tag/fetch?page=' + page + '&size=' + size + sortStr + searchQuery,
			method: "get",
		};
		self.setState({loading: true, manual: self.manual === true ? false : self.manual});
		self.props.reload(true);
		request(params)
				.then(function (response) {
					self.setState({
						page: page,
						size: size,
						total: response.data.totalElements,
						content: response.data.content,
						loading: false,
						enableBtnInteraction: true,
						searching: false,
						selectedAll: false,
						selection: []
					});
					self.props.reload(false);

				}).catch(function (error) {
			self.setState({loading: false});
			self.props.reload(false);
			if (axios.isCancel(error)) {
			} else {
				showAxiosError(error);
			}
		});

	}

	componentDidMount() {
		this.getTagName();

	}

	defineType(data) {
		switch (data.type) {
			case 0:
				return 'Giden İrsaliye';
			case 1:
				return 'Gelen İrsaliye';
			case  2:
				return 'Giden E-Fatura';
			case  3:
				return 'Gelen E-Fatura';
			case  4:
				return 'E-Arşiv Fatura';
			case  5:
				return 'E-Müstahsil Makbuzlar';
			case  6:
				return 'E-Serbest Meslek Makbuzlar';
			case  7:
				return 'E-Gider Pusulası';
			case  8:
				return 'E-Adisyon';
			case 11:
				return 'E-Döviz';

		}
	}

	closeClick() {

		this.setState({addOpen: false});
		this.fetchData(this.state.accessor, this.state.direction, this.state.page, this.state.size);

	}

	deleteTag() {
		let size = this.state.size
		let recordId = this.state.row.recordId;
		let tagName = this.state.row.tagName;
		let type = this.state.row.type;
		let page = this.state.page
		if (recordId) {
			this.setState({disabledLoginBtn: true});
			let self = this;
			let params = {
				url: `/tag/delete/${recordId}`,
				method: "post",
				data: {
					recordId: recordId,
					type: type,
					tagName: tagName,

				}
			};
			request(params)
					.then(function (response) {
						Alert.success("Başarılı bir şekilde işaret silindi.", {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 1500,
							html:false
						});
						self.setState({alert: false});
						self.fetchData(null, null, page, size);
					}).catch(function (error) {
				showAxiosError(error);
				self.setState({disabledLoginBtn: false});
			});
		} else {
			Alert.error("İşaret seçimi yapmalısınız.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 1500,
				html:false
			});
		}
	}

	getTagName() {
		let defineTagList = [];
		if (this.props.hasEirsaliye != null) {
			defineTagList.push({value: "0", label: 'Giden İrsaliye'});
			defineTagList.push({value: "1", label: 'Gelen İrsaliye'});
		}
		if (this.props.hasEFatura != null) {
			defineTagList.push({value: "2", label: 'Giden E-Fatura'});
			defineTagList.push({value: "3", label: 'Gelen E-Fatura'});
		}
		if (this.props.hasEarsiv != null) {
			defineTagList.push({value: "4", label: 'E-Arşiv Fatura'});
		}
		if (this.props.hasEmuhtahsil != null) {
			defineTagList.push({value: "5", label: 'E-Müstahsil Makbuzlar'});
		}
		if (this.props.hasEserbestmeslek != null) {
			defineTagList.push({value: "6", label: 'E-Serbest Meslek Makbuzlar'});
		}
		if (this.props.hasEgiderPusulasi != null) {
			defineTagList.push({value: "7", label: 'E-Gider Pusulası'});
		}
		if(this.props.hasEAdisyon != null){
			defineTagList.push({ value:"8" , label:'E-Adisyon'});
		}
		if (this.props.hasExchange != null) {
			defineTagList.push({value: "11", label: 'E-Döviz'});
		}
		/*if(this.props.hasESigorta != null){
			defineTagList.push({ value:"9" , label:'E-Sigorta'});
		}*/
		this.setState({defineTagList});

	}

	render() {
	    const source = VirtualHost.conf.resourcePrefix;

		const fields = [
			{
				label: "İşaret Adı:",
				accessor: "tagName",
				type: "text",
				operator: "=",
			},
			{
				label: "Hizmet Adı",
				accessor: "type",
				type: "select",
				operator: "=",
				selectData: this.state.defineTagList
			},

		];
		const columns = [

			{
				Header: "İşaret adı",
				title: "İşaret adı",
				accessor: "tagName",
			},
			{
				Header: "Hizmet Adı",
				title: "Hizmet Adı",
				accessor: "type",
				Cell: row => (
						<label>{this.defineType(row)}</label>
				)
			},
			{
				Header: "İşlemler",
				title: "İşlemler",
				accessor: "",
				sortable: false,
				width: "11%",

				Cell: row => (
						<div>
							<button type="button" onClick={() => this.setState({alert: true, row: row})} rel="tooltip"
                                    style={{background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'}}
									disabled={!hasUserRight(UserRightsEnum.settings.tagList.delete, this.props.currentUser)}
									className="Btn btn-icon" title="Sil"
							>
								<i className="fa fa-trash-alt"></i>
							</button>
						</div>
				)
			},

		];


		return (

				<div className="row baseBackground">
					<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
						<StickButton position="leftSide"
									 label="İşaret Ekle"
									 title="İşaret Ekle"
									 disabled={this.state.saveLoading || !hasUserRight(UserRightsEnum.settings.tagList.create, this.props.currentUser)}
									 className="stickButton plus-circle"
									 onClick={(e) => this.setState({addOpen: true})}/>
					</NavBarKS>
					{this.state.alert &&
					<SweetAlert showCancel warning
								confirmBtnText="Onayla"
								cancelBtnText="İptal"
								confirmBtnBsStyle="danger"
								cancelBtnBsStyle="default"
								title="İşareti Silmek İstediğinize Emin misiniz?"
								onConfirm={() => this.deleteTag()}
								onCancel={() => this.setState({alert: false})}
					>
						{'İşaretlenmiş faturalar var ise faturalardan işaretler kaldırılacaktır.'}
					</SweetAlert>

					}

					<div className="col-sm-12 satirBasi">

						<div className="card-header">
							<h4 className="card-title"> İşaret Tanımları </h4>
						</div>
						<div className="card-body">
							<DetailedSearch fields={fields}
											loading={this.state.searching}
											onSearch={this.handleSearch}
							/>
						</div>


						<div>
							{this.state.addOpen &&
							<AddTagList
									hasEFatura={this.props.hasEFatura}
									hasEirsaliye={this.props.hasEirsaliye}
									hasEarsiv={this.props.hasEarsiv}
									hasEmuhtahsil={this.props.hasEmuhtahsil}
									hasEserbestmeslek={this.props.hasEserbestmeslek}
									hasEgiderPusulasi={this.props.hasEgiderPusulasi}
									hasEAdisyon={this.props.hasEAdisyon}
									hasESigorta={this.props.hasESigorta}
									hasExchange={this.props.hasExchange}
									closeClick={this.closeClick}/>
							}
						</div>

						<div className="card-header">
							<Table columns={columns}
								   content={this.state.content}
								   loading={this.state.loading}
								   loadingText="Kayıtlar getiriliyor..."
								   total={this.state.total}
								   page={this.state.page}
								   manual={this.state.manual}
								   size={this.state.size}
								   options={["5", "10", "20", "50", "100"]}
								   fetchData={this.fetchData}/>
						</div>

					</div>
				</div>


		);
	}
}

export default TagList;